<template>
  <div class="row mt-5" v-if="pageCount > 0">
    <div class="col-12">
      <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center flex-wrap">
          <li class="page-item" :class="{'disabled': currentPage === 0}">
            <a class="page-link" href="javascript:void(0)" :disabled="currentPage === 0" @click="search(0)">First</a>
          </li>
          <li class="page-item" :class="{'disabled': currentPage <= 0}">
            <a class="page-link" href="javascript:void(0)" aria-label="Previous" :disabled="currentPage <= 0" @click="search(currentPage-1)">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <template v-for="n in pageCount">
            <li class="page-item" v-if="buttonDisplayStatus[n-1]" :class="{'active': n-1===currentPage}">
              <a class="page-link" href="javascript:void(0)" @click="search(n-1)">{{n}}</a>
            </li>
          </template>
          <li class="page-item" :class="{'disabled': currentPage >= lastPage-1}">
            <a class="page-link" href="javascript:void(0)" aria-label="Next" :disabled="currentPage >= lastPage" @click="search(currentPage+1)">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
          <li class="page-item" :class="{'disabled': currentPage === lastPage-1}">
            <a class="page-link" href="javascript:void(0)" :disabled="currentPage === lastPage" @click="search(lastPage-1)">Last</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationLinks",
  props: {
    totalRecords: {
      type: Number,
      required: false,
      default: 0
    },
    searchMethod: {
      type: Function,
      required: true
    },
    pageIndex: {
      type: Number,
      required: true,
      default: 1
    },
		perPage: {
			type: Number,
			required: true,
			default: 10
		},
		pageCount: {
			type: Number,
			required: true,
			default: 0
		},
  },
  data() {
    return {
      currentPage: 0,
      lastPage: 0,
      buttonCount: 5,
      buttonDisplayStatus: Array(this.pageCount).fill(true)
    };
  },
	updated() {
		if(this.pageCount!=this.buttonDisplayStatus.length){
			this.setPageIndex();
		}
	},
	methods: {
    search(index) {
			if(index==this.currentPage)
				return;
      this.currentPage = index;
      this.searchMethod(this.currentPage);
    },
    setPageIndex() {
      this.currentPage = this.pageIndex;
      this.lastPage = this.pageCount;
      this.buttonDisplayStatus = Array(this.pageCount).fill(true);
      this.calculateButtonDisplayStatus();
    },
    calculateButtonDisplayStatus() {
      if(this.pageCount <= this.buttonCount) return;
      let min = (this.currentPage <= 2) ? 0 : (((this.pageCount - 2) < this.currentPage) ? (this.pageCount - this.buttonCount + 1) : (this.currentPage - 2));
      for(let i=0;i < this.pageCount;i++) {
        if(i < min || i > (min + this.buttonCount - 1))
          this.buttonDisplayStatus[i] = false;
      }
    }
  },
  mounted() {
    this.setPageIndex();
  }
}
</script>

<style scoped>

</style>
